// extracted by mini-css-extract-plugin
export default {"bannerImage":"bannerImage--waaTE"};